import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import toggle from 'components/common/hoc/toggle'
import { formatPhoneNumber } from 'helpers/phone-number'
import { getDividedPromotionsList } from '../../helpers'
import { showPromotionsDetailModalPage } from 'components/PromotionsDetailModalPage/actions'
import { getQuoteServices } from 'selectors/shoppingData'
import PromotionsAndSummary from './PromotionsAndSummary'

const mapStateToProps = ({ myStore, ...state }) => ({
  myStore,
  services: getQuoteServices({ ...state }),
  storePhoneNumber: myStore ? myStore.phoneNumbers[0] : undefined,
  formattedStorePhoneNumber: myStore ? formatPhoneNumber(myStore.phoneNumbers[0]) : undefined
})

const withPromotionProps = withProps(
  ({ appliedPromotions, quoteSummary: { instantSavings, productAndService } = {}}) => ({
    productAndServiceMinusInstantSavings:
    (parseFloat(productAndService) || 0) + (Math.abs(instantSavings || 0)),
    promotions: getDividedPromotionsList(appliedPromotions)
  })
)

export default compose(
  connect(mapStateToProps, { showPromotionsDetailModalPage }),
  withPromotionProps,
  toggle
)(PromotionsAndSummary)
